export default "__VITE_ASSET__xfJ2eKRb__"